import "./MainBackground.css"

const MainBackground = (props: any) => {
    return (
        <div className="container">
        </div>
    )
}

export default MainBackground
